"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskMotherPlantCell = TaskMotherPlantCell;
var jsx_runtime_1 = require("react/jsx-runtime");
var button_component_1 = require("../../ui/button-component");
var text_component_1 = require("../../ui/text-component");
function TaskMotherPlantCell(props) {
    var motherPlant = props.motherPlant, onViewMotherPlant = props.onViewMotherPlant;
    if (!motherPlant) {
        return (0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "small", color: "medium-gray", label: "\u2014" });
    }
    return ((0, jsx_runtime_1.jsx)(button_component_1.ButtonComponent, { label: motherPlant.name, ariaLabel: "Open mother plant ".concat(motherPlant.name), onPress: function () { return onViewMotherPlant(motherPlant.id); }, variant: "ghost", textSize: "small", className: "text-primary-navy underline" }));
}
